import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import { showNotification } from '@epi-actions/overlays';
import emptyApi from '@epi-api/emptyApi';
import { get } from '@epi-helpers/FetchHelpers';
import { ICustomerData } from '@epi-models/pages/Home';

import config from '@epi-config';

export const USER_API_URL = `${config.apiHost}/api/user`;
export const IMPERSONATION_API_URL = `${config.apiHost}/api/admin-tool/impersonation/token`;

export const getImpersonationToken = (guid: string): Promise<any> => {
  return get(`${IMPERSONATION_API_URL}/${guid}`);
};

export const getDetails = async (): Promise<ICustomerData> =>
  get<ICustomerData>(`${USER_API_URL}/details`);
export const userApi = emptyApi.injectEndpoints({
  endpoints: build => ({
    getDetails: build.query<ICustomerData, void>({
      async queryFn(_arg, api) {
        try {
          const data = await getDetails();
          return { data };
        } catch (error) {
          api.dispatch(
            showNotification({ message: 'messages.error' }, 'error')
          );
          return { error: error as FetchBaseQueryError };
        }
      },
      keepUnusedDataFor: 0,
      providesTags: ['userDetails']
    })
  })
});

export const { useGetDetailsQuery, useLazyGetDetailsQuery } = userApi;
